import TokenLogo from '~/components/TokenLogo'
import { getNetworkLogo } from '~/utils/chain'
import {
  StyledTokenWrap,
  StyledTokenWrapLeft,
  StyledTokenSymbol,
  StyledTriangle,
} from './styled'
import IconLock from '~/assets/images/lock.svg'
import IconTriangle from '~/assets/images/triangle-black.svg'

interface TokenProps {
  token: BaseTokenlonToken & {
    chainId?: number
  }
  onClick?: () => void
  needApprove?: boolean
}

export const Token: React.FC<TokenProps> = ({
  token,
  onClick,
  needApprove,
}) => {
  const { logo, symbol, chainId } = token || {}
  const networkLogo = getNetworkLogo(chainId)
  const withSelection = typeof onClick === 'function'

  if (!logo && !symbol) return <StyledTokenWrap />

  return (
    <StyledTokenWrap onClick={onClick}>
      <StyledTokenWrapLeft>
        <TokenLogo
          large
          space={0}
          logo={logo}
          symbol={symbol}
          networkLogo={networkLogo}
          showNetworkBadge={true}
        />
        <StyledTokenSymbol>{symbol}</StyledTokenSymbol>
        {needApprove && (
          <img src={IconLock} style={{ marginLeft: 4 }} alt="lock" />
        )}
      </StyledTokenWrapLeft>
      {withSelection && <StyledTriangle src={IconTriangle} alt="triangle" />}
    </StyledTokenWrap>
  )
}

export default Token
